import instance from "../../utils/axios";

// Convert payload to FormData
const toFormData = (payload) => {
    const formData = new FormData();
    Object.entries(payload || {}).forEach(([key, val]) => {
      if (val !== undefined && val !== null) formData.append(key, val);
    });
    return formData;
  };
  
  const toUrlEncoded = (payload) => {
    const params = new URLSearchParams();
    Object.entries(payload || {}).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        params.append(key, String(val));
      }
    });
    return params;
  };
  
// ✅ Save Team Video
export const saveTeamVideo = async (payload) => {
  const response = await instance.post(
    "/churches/team/membervideos/save",
    toUrlEncoded(payload)
  );
  return response.data;
};


// ✅ Update Team Video
export const updateTeamVideo = async (payload) => {
  const response = await instance.post("/churches/team/membervideos/update", toFormData(payload));
  return response.data;
};

// ✅ Delete Team Video
export const deleteTeamVideo = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload).forEach(([key, val]) => formData.append(key, val ?? ""));
  const response = await instance.post("/churches/team/membervideos/delete", formData);
  return response.data;
};

// ✅ Read Team Videos
export const readTeamVideos = async (payload) => {
  const response = await instance.post("/churches/team/membervideos/read", toFormData(payload));
  return response.data;
};
